module.exports = __webpack_public_path__ + "media/images/front/banner_digital_dental_academy_side-cebbb9b5b9acdb20f513aaf410917c7e.jpg";